import { GET_PINS } from '../../constants/ActionTypes';

export const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: [],
};

export default function pins(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_PINS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_PINS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        result: action.result,
      };
    case `${GET_PINS}_FAIL`:
      return {
        ...state,
        error: 'failed',
        loaded: false,
        loading: false,
      };

    default:
      return state;
  }
}
